import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import StylePropType from 'react-style-proptype';
import TabGroup from './TabGroup';
import Tab from './Tab';

var generateTabMap = function generateTabMap(tabs) {
  return tabs.reduce(function (tabAcc, tab) {
    return _objectSpread({}, tabAcc, _defineProperty({}, tab.id, tab));
  }, {});
};

var validateIcons = function validateIcons(tabs) {
  var tabsWithIcons = tabs.filter(function (tab) {
    return Boolean(tab.icon);
  });
  var isValid = !tabsWithIcons.length || tabsWithIcons.length === tabs.length;

  if (!isValid) {
    console.warn('TabMenu: All tabs must have icons for them to render. Ignoring icons for all tabs...');
  }

  return isValid;
};

var validateDescriptions = function validateDescriptions(tabs) {
  var tabsWithDescriptions = tabs.filter(function (tab) {
    return Boolean(tab.description);
  });
  var isValid = !tabsWithDescriptions.length || tabsWithDescriptions.length === tabs.length;

  if (!isValid) {
    console.warn('TabMenu: All tabs must have descriptions for them to render. Ignoring descriptions for all tabs...');
  }

  return isValid;
};

var TabMenu = function TabMenu(_ref) {
  var activeTabId = _ref.activeTabId,
      tabs = _ref.tabs,
      tabGroups = _ref.tabGroups,
      onTabClick = _ref.onTabClick,
      bodyStyle = _ref.bodyStyle,
      tabStyle = _ref.tabStyle;

  var _useState = useState(generateTabMap(tabs)),
      _useState2 = _slicedToArray(_useState, 2),
      tabMap = _useState2[0],
      setTabMap = _useState2[1];

  var _useState3 = useState(validateIcons(tabs)),
      _useState4 = _slicedToArray(_useState3, 2),
      showIcons = _useState4[0],
      setShowIcons = _useState4[1];

  var _useState5 = useState(validateDescriptions(tabs)),
      _useState6 = _slicedToArray(_useState5, 2),
      showDescriptions = _useState6[0],
      setShowDescriptions = _useState6[1];

  useEffect(function () {
    // Create a lookup mapping of tabs by id to optimize
    setTabMap(generateTabMap(tabs));
    setShowIcons(validateIcons(tabs));
    setShowDescriptions(validateDescriptions(tabs));
  }, [tabs]);

  if (!tabs || !tabs.length) {
    return null;
  }

  var activeTab = tabs[0];

  if (activeTabId) {
    activeTab = tabMap[activeTabId] || activeTab;
  }

  return React.createElement("div", {
    className: "tab-menu"
  }, React.createElement("div", {
    className: "tabs",
    style: tabStyle
  }, tabGroups.length > 1 ? tabGroups.map(function (_ref2) {
    var label = _ref2.label,
        _ref2$tabIds = _ref2.tabIds,
        tabIds = _ref2$tabIds === void 0 ? [] : _ref2$tabIds;
    return React.createElement(TabGroup, {
      key: "".concat(label, "-").concat(tabIds.join('-')),
      label: label
    }, tabIds.map(function (tabId) {
      var _tabMap$tabId = tabMap[tabId],
          id = _tabMap$tabId.id,
          title = _tabMap$tabId.title,
          description = _tabMap$tabId.description,
          icon = _tabMap$tabId.icon;
      return React.createElement(Tab, _extends({
        key: id,
        id: id,
        title: title,
        onTabClick: onTabClick,
        isActive: activeTab.id === id
      }, showIcons ? {
        icon: icon
      } : {}, showDescriptions ? {
        description: description
      } : {}));
    }));
  }) : tabs.map(function (_ref3) {
    var id = _ref3.id,
        title = _ref3.title,
        description = _ref3.description,
        icon = _ref3.icon;
    return React.createElement(Tab, _extends({
      key: id,
      id: id,
      title: title,
      onTabClick: onTabClick,
      isActive: activeTab.id === id
    }, showIcons ? {
      icon: icon
    } : {}, showDescriptions ? {
      description: description
    } : {}));
  })), React.createElement("div", {
    className: "active-tab-body",
    style: bodyStyle
  }, activeTab && activeTab.body));
};

var tabShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  icon: PropTypes.func,
  body: PropTypes.node
});
var tabGroupShape = PropTypes.shape({
  label: PropTypes.string.isRequired,
  tabIds: PropTypes.arrayOf(PropTypes.string).isRequired
});
TabMenu.propTypes = {
  activeTabId: PropTypes.string,
  tabs: PropTypes.arrayOf(tabShape).isRequired,
  tabGroups: PropTypes.arrayOf(tabGroupShape),
  onTabClick: PropTypes.func,
  bodyStyle: StylePropType,
  tabStyle: StylePropType
};
TabMenu.defaultProps = {
  onTabClick: function onTabClick() {},
  tabGroups: [],
  bodyStyle: {},
  tabStyle: {}
};
export default TabMenu;